<template>
    <div class="menu">
        <div class="header-player">
            <div class="header-player-left">
                <div class="header-player-icon">

                    <svg-icon icon="pausa_menu" @click.native="pause" v-if="player.playing"/>
                    <svg-icon icon="play_menu-01" @click.native="play" v-if="!player.playing"/>

                </div>

                <div id="audio-tags" v-cloak>
                    <audio v-for="channel in channels" :id="'radio-' + channel.id"
                           :src="hostWithPort + channel.special_name"
                           preload="none"></audio>
                </div>

                <div id="podcast-audio"></div>

                <div class="header-player-sound">
                    <div class="slider slider--volume player__volume__slider">
                        <input type="range" min="0" max="1" step="0.01" v-model="player.volume" @input=changeVolume()>
                    </div>
                </div>

                <div class="header-player-album">
                    <img v-if="player.playing" class="img" :src="track.cover" alt="album">
                </div>
            </div>

            <div class="header-player-right" @click="changeCurrentTimePercent($event)" id="player-wrap">

                <div class="header-player-artist" v-if="player.playing">
                    <p class="radio-name">
                    <span :class="'r' + currentChannelId">
                        {{getNameFromChannelsArray(currentChannelId)}} {{player.id ? 'podcast' : 'radio'}}
                    </span>
                    </p>
                    <p class="album-name">{{ track.artist }}</p>
                    <p class="song-name">{{ track.title }}</p>
                </div>
                <div class="header-player-time" id="timeleft"></div>

                <div class="header-player-progress" id="player-progress"></div>

            </div>

        </div>

        <div class="header-right">
            <div class="header-btn-donate-wrap" id="donate">
                <a @click="runWfpWdgt" class="header-btn-donate">Donate</a>
            </div>
        </div>

    </div>
</template>

<script>
    import Pusher from 'pusher-js'
    import SvgIcon from '../layout/SvgIcon'

    const socket = new Pusher('ce86a7ca00af7fa6aedb', {
        cluster: 'eu',
        encrypted: true
    })
    const channel = socket.subscribe('radio-status-song')

    import {mapGetters} from 'vuex'

    export default {
        components: {
            SvgIcon
        },

        props: {
            show: Boolean
        },

        computed: mapGetters({
            pkginfo: 'pkg',
            sidebar: 'sidebar'
        }),

        data() {
            let url = 'https://' + window.location.hostname + ':8081/';
            return {
                track: {
                    artist: null,
                    title: null,
                    cover: null,
                    stream_url: '',
                },
                player: {
                    playing: false,
                    volume: 0.5,
                    id: null,
                    channel: null,
                    podcast: null
                },
                currentChannelId: null,

                channels: [],
                audioTags: [],
                hostWithPort: url,
            }
        },

        methods: {
            getNameFromChannelsArray(id) {
                console.log(id);
                console.log(this.channels);
                let found = this.channels.find(function (element) {
                    return element.id === id
                })
                return found.name
            },

            runWfpWdgt() {
                let wayforpay = new Wayforpay()
                wayforpay.invoice('https://secure.wayforpay.com/button/bb0e0170900c5')
            },

            click() {
                this.$http.get('api/user')
            },

            loadStreamData() {
                this.$http.get('/api/channels')
                    .then(response => {
                        this.channels = response.data;
                        if (!Array.isArray(this.channels) || !this.channels.length) {
                            return;
                        }
                        if (!this.currentChannelId) {
                            this.currentChannelId = this.channels[0].id;
                            this.player.channel = this.currentChannelId;
                        }
                        this.getChannelInfo(this.currentChannelId);
                    })
            },

            getChannelInfo(channelId) {
                this.$http.get('/api/stream/getInfo/' + channelId)
                    .then(response => {
                        this.track = response.data.info
                    })
            },

            pause() {
                let id = this.player.id ? this.player.id : this.currentChannelId
                let audio = document.getElementById('radio-' + id)
                audio.pause()
                this.player.playing = false
                this.player.id = null
                this.sendPlayerEvent('pause')
            },

            play() {
                let id = this.player.id ? this.player.id : this.currentChannelId
                if (!this.player.id) {
                    this.loadStreamData()
                }
                let audio = document.getElementById('radio-' + id)
                audio.load()
                audio.play()
                this.player.playing = true
                this.sendPlayerEvent('play')
            },

            changeVolume() {
                let id = this.player.id ? this.player.id : this.currentChannelId
                let audio = document.getElementById('radio-' + id)
                audio.volume = this.player.volume
            },

            setCurrentChannel() {
                this.currentChannelId = this.$store.state.channel_id
            },

            sendPlayerEvent(status) {
                this.$root.$emit('radio-play', {
                    player: this.player,
                    status: status
                })
            },

            listenPlayerUpdate() {
                this.$root.$on('radio-play', (item) => {
                    this.player = item.player
                    this.currentChannelId = item.player.channel

                    if (!item.status) {
                        item.podcast ? this.track = item.podcast : this.loadStreamData()
                    }

                    this.listenAudioError()
                })
            },

            updateStream() {
                this.$http.post('/api/stream/update', {
                    channel_id: this.currentChannelId,
                })
            },

            listenEvents() {
                let self = this

                channel.bind('end-of-song', function (data) {
                    if (!self.player.id && data.track.channel_id == self.currentChannelId) {
                        self.track = data.track
                    }
                })

                channel.bind('end-of-playlist', function (data) {
                    if (data.channel_id == self.currentChannelId) {
                        self.updateStream()
                        self.loadStreamData()
                    }
                })
            },

            changeCurrentTimePercent(event) {
                if (this.player.id) {
                    let audio = document.getElementById('radio-' + this.player.id)
                    let click_c = event.layerX
                    let width_c = document.getElementById('player-wrap').offsetWidth
                    let perc_pr = Math.floor(click_c / (width_c / 100))
                    let track_l = Math.floor(audio.duration)
                    let track_cur = Math.floor((track_l / 100) * perc_pr)

                    document.getElementById('player-progress').style.width = perc_pr + '%'
                    audio.currentTime = track_cur
                }
            },

            addAudio(channel_id, special_name) {
                let new_audio = document.createElement('audio')
                new_audio.id = 'radio-' + channel_id
                new_audio.src = this.hostWithPort + special_name

                document.getElementById('audio-tags').appendChild(new_audio)
                let audio = document.getElementById('radio-' + channel_id)
                audio.play()

                let self = this
                audio.onerror = function () {
                    console.log('error')
                    audio.remove()
                    self.addAudio(channel_id, special_name)
                }
            },

            listenAudioError() {
                let self = this

                console.log('listen errors')
                for (let i = 0; i < this.channels.length; i++) {
                    this.audioTags[i] = document.getElementById('radio-' + this.channels[i].id)
                    this.audioTags[i].onerror = function () {
                        console.log('error' + self.currentChannelId)

                        self.audioTags[i].remove()
                        self.addAudio(self.channels[i].id, self.channels[i].special_name)
                    }
                }
            }


        },

        mounted() {
            this.loadStreamData()
            this.setCurrentChannel()

            this.listenPlayerUpdate()
            this.listenEvents()
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/Navbar.vue